import { render } from "./subjects.html?vue&type=template&id=155c6523&external"
import script from "./subjects.js?vue&type=script&lang=js&external"
export * from "./subjects.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__